import { useState, useEffect } from "react"
import { useFirestore, useUser } from "reactfire"
import { doc, onSnapshot } from "firebase/firestore"

export function useRol() {
  const { data: user, status: userStatus } = useUser()
  const firestore = useFirestore()

  const [estado, setEstado] = useState({ rol: null, unidad: null, cargando: true })

  useEffect(() => {
    if (userStatus === "loading") return

    if (!user?.uid) {
      setEstado({ rol: null, unidad: null, cargando: false })
      return
    }

    // onSnapshot mantiene el rol sincronizado en tiempo real
    // resuelve el caso donde rol llega null en el primer render con getDoc
    const unsub = onSnapshot(
      doc(firestore, "users", user.uid),
      (snap) => {
        if (snap.exists()) {
          const data = snap.data()
          setEstado({ rol: data.rol ?? null, unidad: data.unidad ?? null, cargando: false })
        } else {
          setEstado({ rol: null, unidad: null, cargando: false })
        }
      },
      (err) => {
        console.error("useRol error:", err)
        setEstado({ rol: null, unidad: null, cargando: false })
      }
    )

    return () => unsub()
  }, [user?.uid, userStatus, firestore])

  return estado
}